"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterNonHTMLProps = exports.joinClasses = exports.__BaseInputComponent = exports.defaultCSSClasses = void 0;
var s_js_1 = require("s-js");
var form_state_1 = require("./form-state");
var util_1 = require("./util");
exports.defaultCSSClasses = {
    // using boostrap
    default: "",
    error: "",
};
function updateInputState(inputState, nextValue, tests, isChanged) {
    inputState.value = nextValue;
    inputState.isChanged = isChanged(nextValue, inputState.startValue);
    inputState.error = testErrors(inputState, tests);
    inputState.__v += 1;
}
/** Look over props and determine which tests are needed */
function createValidationTests(props) {
    var errors = [];
    var p = props;
    if (p.min && p.type === "number") {
        errors.push({ type: form_state_1.FormError.MinNumberLen, value: Number(p.min) });
    }
    else if (p.min) {
        errors.push({ type: form_state_1.FormError.MinStrLen, len: Number(p.min) });
    }
    if (p.max && p.type === "number") {
        errors.push({ type: form_state_1.FormError.MaxNumberLen, value: Number(p.max) });
    }
    else if (p.max) {
        errors.push({ type: form_state_1.FormError.MaxStrLen, len: Number(p.max) });
    }
    if (p.required)
        errors.push({ type: form_state_1.FormError.Required });
    if (p.type === "email")
        errors.push({ type: form_state_1.FormError.EmailRegex });
    if (p.regex)
        errors.push({ type: form_state_1.FormError.StrRegex, regex: p.regex });
    if (p.validate)
        errors.push({ type: form_state_1.FormError.ValidateFn, fn: p.validate });
    return errors;
}
/**
 *
 * Update Use cases
 * 1. Initial update (constructor)
 *      - must update prop.data signal so that error is set
 *      - isTouch must not be changed
 * 2. Internal update (triggered by input's "change" event)
 *     - triggers S computation(, ...)
 *     - isTouched must be set to true
 * 3. External update
 *     - caused by an update on the props.data object
 *     - this include updates triggered by user input. There are guards to ignore these external updates.
 *     - isTouched is set to the value on the props.data
 * */
function __BaseInputComponent(props, getInputStateValue, convertToInputState, render, isChanged) {
    if (isChanged === void 0) { isChanged = compareRef; }
    var initialInput = s_js_1.default.sample(props.data);
    var signal = s_js_1.default.data(getInputStateValue(initialInput, undefined));
    var validations = createValidationTests(props);
    var currVersion = -1;
    var isExternal = true;
    var timer = -1;
    var hasPendingInput = false;
    s_js_1.default.on(props.data, function () {
        var signalValue = getInputStateValue(props.data(), s_js_1.default.sample(signal));
        isExternal = true;
        signal(signalValue);
    }, undefined, true);
    s_js_1.default(function () {
        var curr = convertToInputState(signal());
        var propsData = s_js_1.default.sample(props.data);
        var isExternalPropsUpdate = propsData.__v !== currVersion;
        if (props.triggerOnBlur && !isExternalPropsUpdate)
            return; // handleOnBlur will trigger an update
        // There are two way to trigger this S computation.
        // 1. Internal (user-driven) changes to an input field.
        // 2. External changes to props.data
        // To prevent runaway recursive updates we have two guards. The current value of the user's input is
        // checked against props.data.value. When different it means the user has manually changed the input.
        // With only this guard, external updates to other fields on InputState would not work.
        // For ex. changes to isDisabled. For this reason __v can be incremented to force an update.
        if (curr !== propsData.value || isExternalPropsUpdate) {
            currVersion = propsData.__v;
            debounceInput(curr, props.debounce, false);
        }
    });
    return render(signal, function () { return handleOnBlur(); });
    function handleOnBlur() {
        // If hasPendingInput == true, then this input has a debounce value. The blur event shows the user has
        // finished using the input, so we should update immediately rather than wait for the remainder of hte
        // debounce.
        // Otherwise it should be obvious why we check for props.onBlur
        if (hasPendingInput || props.triggerOnBlur) {
            debounceInput(convertToInputState(s_js_1.default.sample(signal)), 0, true);
        }
        // Special case. The very first time we lose focus, update inputstate so we set isTouched
        else if (!s_js_1.default.sample(props.data).isTouched) {
            isExternal = false;
            debounceInput(convertToInputState(s_js_1.default.sample(signal)), 0, true);
        }
    }
    function debounceInput(input, debounceTime, updateTouched) {
        if (debounceTime === void 0) { debounceTime = form_state_1.globalConfig.debounceTime; }
        if (updateTouched === void 0) { updateTouched = false; }
        hasPendingInput = true;
        if (timer !== -1)
            clearTimeout(timer);
        // Always update asynchronously to avoid infinite update cycles
        // special case. Evalulate input on first render (__v === 0). Even for debounced input
        if (s_js_1.default.sample(props.data).__v === 0 || debounceTime === 0) {
            bounce();
        }
        else {
            timer = window.setTimeout(function () { return bounce(); }, debounceTime);
        }
        function bounce() {
            var curr = s_js_1.default.sample(props.data);
            var next = __assign({}, curr);
            updateInputState(next, input, validations, isChanged);
            // Only update isTouched for internal events
            next.isTouched = isExternal || !updateTouched ? next.isTouched : true;
            currVersion = next.__v; // Remember this value so that the next S computation cause an update.
            props.data(next);
            hasPendingInput = false;
            isExternal = false;
        }
    }
}
exports.__BaseInputComponent = __BaseInputComponent;
function compareRef(a, b) {
    return a !== b;
}
function joinClasses(props, errorClasses) {
    return ((props.class || "") +
        " " +
        ((props.data().isTouched && props.data().error
            ? errorClasses.error
            : errorClasses.default) || ""));
}
exports.joinClasses = joinClasses;
var regexes = {
    url: /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
    email: /.+?@.+/,
};
function testErrors(input, tests) {
    for (var _i = 0, tests_1 = tests; _i < tests_1.length; _i++) {
        var test = tests_1[_i];
        switch (test.type) {
            case form_state_1.FormError.StrRegex: {
                var res = input.value.match(new RegExp(test.regex));
                if (res == null)
                    return test.type;
                break;
            }
            case form_state_1.FormError.EmailRegex: {
                var res = input.value.match(new RegExp(regexes.email));
                if (res == null)
                    return test.type;
                break;
            }
            case form_state_1.FormError.ValidateFn: {
                var res = test.fn(input.value);
                if (res !== 0)
                    return res;
                break;
            }
            case form_state_1.FormError.MinStrLen: {
                if (input.value.length < test.len)
                    return test.type;
                break;
            }
            case form_state_1.FormError.MaxStrLen: {
                if (input.value.length > test.len)
                    return test.type;
                break;
            }
            case form_state_1.FormError.MinNumberLen: {
                if (input.value < test.value)
                    return test.type;
                break;
            }
            case form_state_1.FormError.MaxNumberLen: {
                if (input.value > test.value)
                    return test.type;
                break;
            }
            case form_state_1.FormError.Required: {
                var isNumber = typeof input.value === "number";
                if (!isNumber && !input.value)
                    return test.type;
                break;
            }
            default:
                util_1.assertNever(test);
        }
    }
    return 0;
}
function filterNonHTMLProps(props) {
    var inputProps = __assign({}, props);
    if (inputProps.type)
        inputProps.type = props.type === "number" ? "text" : props.type;
    var optProps = inputProps;
    delete optProps.options;
    delete optProps.classes;
    delete optProps.radioClass;
    if (!(optProps.type === "range" || optProps.type == "number"))
        delete optProps.max;
    if (!(optProps.type === "range" || optProps.type == "number"))
        delete optProps.min;
    delete optProps.regex;
    delete optProps.selector;
    delete optProps.trimWhitespace;
    delete optProps.validate;
    delete optProps.data;
    delete optProps.debounce;
    delete optProps.required;
    delete optProps.children;
    delete optProps.legendText;
    delete optProps.prefixComponent;
    delete optProps.postfixComponent;
    delete optProps.triggerOnBlur;
    delete optProps.onBlur;
    return inputProps;
}
exports.filterNonHTMLProps = filterNonHTMLProps;
//# sourceMappingURL=internal-components.jsx.map